import React, { useState, useEffect } from 'react';
import { 
  Overridable, 
  OverridableNumber, 
  UpgradableNumber 
} from "@dndModels";
import CommonUtilities from "@utilities/common_utilities";

import OverridableInput from "@dndComponents/other/OverridableInput";
import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";

interface Props {
  name: string;
  obj: OverridableNumber;
  change_time: number;
  can_inherit: boolean;
  can_creature: boolean;
  disabled?: boolean;
  log_it?: boolean;
  onChange: (changed: OverridableNumber) => void;
}

const common_util = CommonUtilities.getInstance();

export default function OverridableNumberInput({ 
  name,
  obj, 
  change_time, 
  can_inherit,
  can_creature,
  disabled = false,
  log_it = false,
  onChange,
}: Props) {
  const [changed, setChanged] = useState(change_time);

  
  useEffect(() => {
    if (change_time !== changed) {
      setChanged(change_time);
    }
    // eslint-disable-next-line
  }, [change_time]);

  if (log_it) {
    console.log(obj);
  }
  return (
    <OverridableInput
      name={name}
      obj={obj}
      change_time={changed}
      can_inherit={can_inherit}
      can_creature={can_creature}
      disabled={disabled}
      onChange={(overridable: Overridable) => {
        // debugger;
        if (overridable instanceof OverridableNumber) {
          const new_obj = obj;
          new_obj.copy(overridable);
          onChange(new_obj);
          setChanged(common_util.get_time_number());
        }
      }}
    >
      <UpgradableNumberBox
        name=""
        value={obj.value}
        disabled={disabled}
        log_it={log_it}
        onChange={(upNum: UpgradableNumber) => {
          const new_obj = obj;
          new_obj.value.copy(upNum);
          onChange(new_obj);
          setChanged(common_util.get_time_number());
        }}
      />
    </OverridableInput>
  ); 
}